module.exports = __webpack_public_path__ + "static/media/mz.e500b5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mz.png
// module id = 1937
// module chunks = 0